import React from 'react';
import { Card, CardBody, Row, Col, Label, Button, Alert } from "reactstrap";
import {
  Textbox,
  Textarea as Textarea1,
  Select as Select1,
  Select as Select2,
  Select as Select3,
  Checkbox
} from "react-inputs-validation";





const Textarea = ({ id, type, input, value, name, placeholder, onChange, validationCallback, maxLength, minLength, length, required, reg, mensajeError, validate, hasError, validacionYup,
  mensajeErrorYup }) => {


  return (
    <div>



      {
        <Textarea1
          type="input"
          value={value}
          validate={validate}
          name={name}
          id={id}
          classNameInput={"form-control"}
          onChange={(value, e) => {
            onChange(value)
          }}
          placeholder={placeholder} // Optional.[String].Default: "".
          validationCallback={res => {
            validationCallback(res)
          }} // Optional.[Func].Default: none. Return the validation result.
          onBlur={e => {

          }}
          validationOption={{
            required: required,
            maxlength: maxLength,
            length: length,
            //  type: "number", // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
            // reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
            msgOnError:
              mensajeError
          }}
        />



      }

      {validacionYup &&

        <label className='react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp'>
          {mensajeErrorYup}
        </label>
      }
    </div>
  );
};

export default Textarea;
